import React from 'react';
import _isFunction from 'lodash/isFunction';
import { DatePicker } from 'baseui/datepicker';

import { MIN_DATE_OBJECT, MAX_DATE_OBJECT, QUICK_SELECT_OPTIONS } from './constants';

interface IHandleOnChangeProps {
	date: Date | Date[];
}
interface IDateRangeProps {
	value: any;
	onChange: (value: any) => void;
	range?: boolean;
	quickSelect?: boolean;
	formatString?: string;
	ariaLabel?: string;
	onChangeCallback?: any;
}

const DateRange: React.FC<IDateRangeProps> = (props) => {
	const { value, onChange, range = true, quickSelect = true, formatString = 'dd/MM/yyyy', onChangeCallback } = props;

	const handleOnChange = ({ date }: IHandleOnChangeProps) => {
		if (_isFunction(onChange)) {
			onChange(date);
		}
		if (_isFunction(onChangeCallback)) {
			onChangeCallback(props);
		}
	};

	return (
		<DatePicker
			{...props}
			range={range}
			quickSelect={quickSelect}
			formatString={formatString}
			onChange={handleOnChange}
			value={value}
			maxDate={MAX_DATE_OBJECT}
			minDate={MIN_DATE_OBJECT}
			quickSelectOptions={QUICK_SELECT_OPTIONS}
		/>
	);
};

export default DateRange;
